import { render } from "./orgDetails.vue?vue&type=template&id=5632af1e"
import script from "./orgDetails.vue?vue&type=script&lang=js"
export * from "./orgDetails.vue?vue&type=script&lang=js"

import "./orgDetails.vue?vue&type=style&index=0&id=5632af1e&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__